
import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import "./Leaderboard.css";
import awlLogo from "./awl-logo.png";
import { db } from "./firebase";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";

const lastMonthWinners = [
  { rank: 1, name: "Suresh Kumar", points: 195, initial: "S" },
  { rank: 2, name: "Anand Sharma", points: 180, initial: "A" },
  { rank: 3, name: "Kavita Reddy", points: 172, initial: "K" },
];

export default function Leaderboard() {
  const [allTimeData, setAllTimeData] = useState([]);
  const [champsType, setChampsType] = useState("allTime");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (champsType === "allTime") {
      setLoading(true);
      const fetchAllTime = async () => {
        try {
          const q = query(
            collection(db, "employees"),
            orderBy("leaderboardScore", "desc"),
            limit(10)
          );
          const snapshot = await getDocs(q);
          const data = [];
          let rank = 1;
          snapshot.forEach((doc) => {
            const d = doc.data();
            data.push({
              rank,
              name: d.name,
              team: d.location,
              points: d.leaderboardScore,
            });
            rank++;
          });
          setAllTimeData(data);
        } catch (err) {
          console.error("Error fetching leaderboard:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchAllTime();
    }
  }, [champsType]);

  // Find user data if present
  const userData = allTimeData.find((u) => u.name && u.name.toLowerCase().includes("you"));
  const topPerformer = allTimeData[0];

  useEffect(() => {
    if (userData && userData.rank === 1) {
      confetti({ particleCount: 100, spread: 80, origin: { y: 0.6 } });
    }
  }, [userData]);

  return (
    <div>
      <div className="app-header">
        <h1 className="app-name-header">
          insight<span className="app-name-highlight">360</span>
        </h1>
        <img src={awlLogo} alt="AWL Logo" className="company-logo-header" />
      </div>

      <div className="main-content leaderboard-page">
        <h2 className="page-title">Leaderboard</h2>

        <div className="card">
          <div className="card-header champs-header">
            <div className="champs-toggle">
              <button
                className={`toggle-btn ${champsType === "monthly" ? "active" : ""}`}
                onClick={() => setChampsType("monthly")}
              >
                Last Month
              </button>
              <button
                className={`toggle-btn ${champsType === "allTime" ? "active" : ""}`}
                onClick={() => setChampsType("allTime")}
              >
                All-Time
              </button>
            </div>
          </div>
          <div className="champs-container">
            {champsType === "monthly"
              ? lastMonthWinners.map((winner) => (
                  <div key={winner.rank} className={`champ-card rank-${winner.rank}`}>
                    <div className="champ-medal">{winner.rank === 1 ? "🥇" : winner.rank === 2 ? "🥈" : "🥉"}</div>
                    <div className="champ-avatar">{winner.initial}</div>
                    <p className="champ-name">{winner.name}</p>
                    <p className="champ-points">{winner.points} pts</p>
                  </div>
                ))
              : null}
          </div>
        </div>

        {/* All-Time: Show first rank card below top bar and monthly champs */}
        {champsType === "allTime" && topPerformer && (
          <div className="top-performer-card-new" style={{ marginTop: "1rem" }}>
            <div className="performer-rank-new">
              <span className="crown">👑</span> #{topPerformer.rank}
            </div>
            <div className="performer-avatar-new">{topPerformer.name && topPerformer.name[0]}</div>
            <div className="performer-details-new">
              <p className="performer-name-new">{topPerformer.name}</p>
              <p className="performer-team-new">{topPerformer.team}</p>
            </div>
            <div className="performer-points-new">{topPerformer.points} pts</div>
          </div>
        )}

        {/* All-Time: List ranks 2-10 below first rank card */}
        {champsType === "allTime" && (
          <div className="leaderboard-list">
            {loading ? (
              <div style={{ textAlign: "center", padding: "1rem" }}>Loading...</div>
            ) : (
              allTimeData
                .filter((user) => user.rank !== 1)
                .map((user) => (
                  <div key={user.rank} className="leaderboard-item">
                    <div className="item-rank">#{user.rank}</div>
                    <div className="item-details">
                      <p className="item-name">{user.name}</p>
                      <p className="item-team">{user.team}</p>
                    </div>
                    <div className="item-points">{user.points} pts</div>
                  </div>
                ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}